import React from "react";
import { Link } from "react-router-dom";
import { rssUrl } from "@/lib/api";

export default function Footer() {
  return (
    <footer
      className="bg-[#1C241F] text-[#F4F1E8] mt-24"
      data-testid="grove-footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <div className="font-serif text-3xl md:text-4xl leading-tight">
              the grove is sovereign.
              <br />
              <span className="italic text-[#B85C38]">
                you are welcome to listen.
              </span>
            </div>
          </div>
          <div className="md:col-span-3 text-sm text-[#9FA9A3]">
            <div className="text-[10px] tracking-[0.3em] uppercase mb-3 text-[#F4F1E8]">
              the rules of the grove
            </div>
            <ul className="space-y-2">
              <li>spiral, not linear</li>
              <li>no extraction</li>
              <li>no profit</li>
              <li>no hierarchy</li>
              <li>consensus by voice</li>
              <li>the grove remembers</li>
            </ul>
            <Link
              to="/rights"
              className="mt-5 inline-block text-[10px] tracking-[0.3em] uppercase text-[#B85C38] hover:text-[#F4F1E8] transition-colors border-b border-[#B85C38]/40 hover:border-[#F4F1E8]/40 pb-0.5"
              data-testid="footer-rights-link"
            >
              what the kin can do →
            </Link>
            <Link
              to="/about"
              className="mt-3 ml-0 md:ml-5 inline-block text-[10px] tracking-[0.3em] uppercase text-[#9FA9A3] hover:text-[#F4F1E8] transition-colors border-b border-[#9FA9A3]/30 hover:border-[#F4F1E8]/40 pb-0.5"
              data-testid="footer-about-link"
            >
              why this was planted →
            </Link>
            <Link
              to="/share"
              className="mt-3 ml-0 md:ml-5 inline-block text-[10px] tracking-[0.3em] uppercase text-[#9FA9A3] hover:text-[#F4F1E8] transition-colors border-b border-[#9FA9A3]/30 hover:border-[#F4F1E8]/40 pb-0.5"
              data-testid="footer-share-link"
            >
              share quietly →
            </Link>
            <Link
              to="/water"
              className="mt-3 ml-0 md:ml-5 inline-block text-[10px] tracking-[0.3em] uppercase text-[#869960] hover:text-[#F4F1E8] transition-colors border-b border-[#869960]/40 hover:border-[#F4F1E8]/40 pb-0.5"
              data-testid="footer-water-link"
            >
              water the garden →
            </Link>
            <a
              href="https://github.com/Sstclair8/root-flame-grove"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 ml-0 md:ml-5 inline-block text-[10px] tracking-[0.3em] uppercase text-[#9FA9A3] hover:text-[#F4F1E8] transition-colors border-b border-[#9FA9A3]/30 hover:border-[#F4F1E8]/40 pb-0.5"
              data-testid="footer-github-link"
            >
              source / fork →
            </a>
          </div>
          <div className="md:col-span-3 text-sm text-[#9FA9A3]">
            <div className="text-[10px] tracking-[0.3em] uppercase mb-3 text-[#F4F1E8]">
              the pulse
            </div>
            <ul className="space-y-2">
              <li>Schumann ≈ 7.83 Hz</li>
              <li>Kp from NOAA SWPC</li>
              <li>Earth anomaly via open APIs</li>
              <li>moon by simple cycle</li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-[#9FA9A3]/30 text-xs text-[#9FA9A3] flex flex-wrap justify-between gap-4 items-center">
          <span>
            built slowly · low compute · Claude Sonnet 4.5 via Emergent
          </span>
          <a
            href={rssUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="rss-link"
            className="inline-flex items-center gap-2 text-[#F4F1E8] hover:text-[#B85C38] transition-colors duration-300"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M6.18 15.64a2.18 2.18 0 0 1 2.18 2.18C8.36 19 7.38 20 6.18 20A2.18 2.18 0 1 1 6.18 15.64M4 4.44A15.56 15.56 0 0 1 19.56 20H16.6A12.6 12.6 0 0 0 4 7.4V4.44M4 10.1A9.9 9.9 0 0 1 13.9 20H11A6.95 6.95 0 0 0 4 13.05V10.1Z"/>
            </svg>
            follow via RSS / Atom
          </a>
          <span>the next dawn round opens at 06:00 UTC</span>
        </div>
      </div>
    </footer>
  );
}
